import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import Vuetify from '@/plugins/vuetify';
import 'vuetify/dist/vuetify.min.css';

import confirmPlugin from '@/plugins/confirm';
import { abilitiesPlugin } from '@casl/vue';

import AxiosHelper from '@/helpers/axiosHelper';
import { extendCaslCanMixin } from '@/helpers/caslHelper';
import { downloadBlobMixin, openLinkMixin } from '@/helpers/vueMixins';

import Default from '@/layouts/Default.vue';
import Login from '@/layouts/Login.vue';
import PurchaseOrder from '@/layouts/PurchaseOrder.vue';
import PurchaseOrderShippingLabel from '@/layouts/PurchaseOrderShippingLabel.vue';
import UsersManagement from '@/layouts/UsersManagement.vue';
import Workload from '@/layouts/Workload.vue';
import i18n from './i18n';
import App from './App.vue';
import router from './router';
import { store, ability } from './store/index';

AxiosHelper.configureAxios(store, router);

router.beforeEach(
  (to, from, next) => {
    const { isAuthorized } = store.state.auth;
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

    if (requiresAuth && !isAuthorized) {
      next({ name: 'login', query: { from: to.fullPath } });
    } else {
      next();
    }
  },
);

Vue.component('default-layout', Default);
Vue.component('login-layout', Login);
Vue.component('purchase-order-layout', PurchaseOrder);
Vue.component('purchase-order-shipping-label-layout', PurchaseOrderShippingLabel);
Vue.component('users-management-layout', UsersManagement);
Vue.component('workload-layout', Workload);

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(confirmPlugin);
Vue.use(abilitiesPlugin, ability);

extendCaslCanMixin();
downloadBlobMixin();
openLinkMixin();

// eslint-disable-next-line no-console
console.info(`%c SAT v${process.env.VERSION} `, 'font-size:12px;background-color:#1565c0;color:#fff;border-radius:10px');
new Vue({
  vuetify: Vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
  ...App,
}).$mount('#app');
